import { DotMatrix } from '@clickguard/design-system'
import { BarChartSquare02 } from '@untitled-ui/icons-react/build/cjs'

// Per-chart placeholder: the DS DotMatrix while the breakdown query is loading, or a
// "no data" state when it resolves empty. Sized to fill the panel body like a
// real chart, so panels keep their footprint instead of collapsing.
export const ChartPanelStatus = ({ mode }: { mode: 'loading' | 'empty' }) => (
	<div
		className="flex flex-1 flex-col items-center justify-center gap-3 px-4 py-10 text-center"
		style={{ minHeight: 220 }}
	>
		{mode === 'loading' ? (
			<DotMatrix size="md" label="Loading chart" />
		) : (
			<>
				<span className="flex h-9 w-9 items-center justify-center rounded-[10px] bg-white shadow-sm ring-1 ring-[#ececf5]">
					<BarChartSquare02 className="h-4 w-4 text-gray-400" />
				</span>
				<p className="text-[13px] text-gray-500">No data for this selection</p>
			</>
		)}
	</div>
)

